import React from "react";

const Shadow = () => (
  <div className="h-100 w-100 absolute top-0 left-0 bg-shadow" />
);

export default Shadow;



// WEBPACK FOOTER //
// ./src/components/Shadow.js